import { render, staticRenderFns } from "./CellRendererPopularity.vue?vue&type=template&id=723b6412"
import script from "./CellRendererPopularity.vue?vue&type=script&lang=js"
export * from "./CellRendererPopularity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports